export default __webpack_public_path__ + "static/media/tequity.e1877f7b.svg";